import { Component } from '@verndale/core';
import { debounce } from 'lodash';
import { BREAKPOINTS } from '../constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $triggers: this.el._$$('.floor-plans-row__trigger'),
      $sectionHead: this.el._$('.floor-plans-row__section-head'),
      $panelContainers: this.el._$$('.floor-plans-row__panel-container'),
      $closeButtons: this.el._$$('.floor-plans-row__panel-close-button'),
      $backButtons: this.el._$$('.floor-plans-row__panel-back-button'),
      $disclaimer: this.el._$('.floor-plans-row__panel-disclaimer'),
      $panelsDetailsDesktop: this.el._$$('.floor-plans-row__panel-details-container-desktop'),
      $panelInners: this.el._$$('.floor-plans-row__panel-inner'),
      $prevButtons: this.el._$$('.floor-plans-row__panel-prev-button'),
      $nextButtons: this.el._$$('.floor-plans-row__panel-next-button'),
      $bottomControls: this.el._$('.floor-plans-row__panel-controls-bottom'),
      $modals: this.el._$$('.modal'),
      $anchorsInDisclaimer: this.el._$$('[href^="#"]')
    };
    this.backButtonLabel = this.el.dataset.backLabel
    this.viewDetailsLabel = this.el.dataset.detailsLabel
    this.currentSlide = -1;
    this.prevContainer;
    this.nextContainer;
    this.displayType = '';
    this.dom.$backButtons.forEach(el => el._$('.link__label').innerText = this.backButtonLabel);
    this.dom.$triggers.forEach(el => el._$('.link__label').innerText = this.viewDetailsLabel);

    if (!this.dom.$el.classList.contains('isExperienceEditor')){
      this.setSlidesHeight();
    } else {
      this.removePanelsAndModals();
    }
  }

  removePanelsAndModals(){
    this.dom.$panelContainers.forEach(el => el.remove())
    this.dom.$modals.forEach(el => el.remove())
  }

  setSlidesHeight(){
    window.matchMedia(`(min-width: ${BREAKPOINTS.TABLET_LANDSCAPE}px)`).matches ?  this.displayType = 'flex' : this.displayType = 'block'
    this.dom.$panelContainers.forEach(el => el.style.display = this.displayType)
    const maxHeight = 0;
    // this.dom.$panelsDetailsDesktop.forEach(el => {
    //   el.style.height = null
    //   if (el.offsetHeight > maxHeight) maxHeight = el.offsetHeight;
    // })
    // if (window.matchMedia(`(min-width: ${BREAKPOINTS.TABLET_LANDSCAPE}px)`).matches){
    //   const bottomControlsHeight = this.dom.$bottomControls.offsetHeight;
    //   this.dom.$panelsDetailsDesktop.forEach(el => {
    //     el.style.height = `${maxHeight+bottomControlsHeight+150}px`;
    //   })
    // }

    this.dom.$panelContainers.forEach(el =>  {
      if (!el.classList.contains('active')) el.style.display = 'none';
      else el.style.display = this.displayType;
    })

  }

  addListeners() {
    if (!this.dom.$el.classList.contains('isExperienceEditor')){
      this.dom.$triggers._on('click', this.handlePanelActivation.bind(this));
      this.dom.$closeButtons.forEach(el => el._on('click', this.handleClose.bind(this)));
      this.dom.$backButtons.forEach(el => el._on('click', this.handleClose.bind(this)));
      this.dom.$panelContainers.forEach(el => el._on('transitionend', this.handleTransitionEnd.bind(this)));
      this.dom.$prevButtons.forEach(el => el._on('click', this.handlePrevClick.bind(this)));
      this.dom.$nextButtons.forEach(el => el._on('click', this.handleNextClick.bind(this)));
      this.dom.$modals.forEach(el => el.addEventListener('modalopen', this.handleModalOpen.bind(this)));
      this.dom.$modals.forEach(el => el.addEventListener('modalclose', this.handleModalClose.bind(this)));
      this.dom.$anchorsInDisclaimer._on('click', this.handleAnchorLinkClick.bind(this));
      window.addEventListener('resize', debounce(this.setSlidesHeight.bind(this), 300));
    }
  }

  async showPanel(panelContainer) {
    panelContainer.style.display = this.displayType;
    panelContainer.hidden = false;
    // eslint-disable-next-line no-undef
    await new Promise(resolve => {
      requestAnimationFrame(() => resolve());
    });

    this.checkNavigationButtonsLabels();
    this.checkDisclaimer();
    requestAnimationFrame(() => panelContainer.classList.add('active'))
  }

  checkNavigationButtonsLabels(){
    const currentContainer = this.dom.$panelContainers[this.currentIndex]
    this.prevContainer = this.dom.$panelContainers[this.currentIndex-1]
    this.nextContainer = this.dom.$panelContainers[this.currentIndex+1]

    if (this.prevContainer){
      currentContainer._$('.floor-plans-row__panel-prev-button .link__label').innerHTML = this.prevContainer.querySelector('.floor-plans-row__panel-heading').innerHTML;
    } else {
      currentContainer._$('.floor-plans-row__panel-prev-button .link__label').innerHTML = ''
      currentContainer._$('.floor-plans-row__panel-prev-button').disabled = true;
    }

    if (this.nextContainer){
      currentContainer._$('.floor-plans-row__panel-next-button .link__label').innerHTML = this.nextContainer.querySelector('.floor-plans-row__panel-heading').innerHTML;
    } else {
      currentContainer._$('.floor-plans-row__panel-next-button .link__label').innerHTML = ''
      currentContainer._$('.floor-plans-row__panel-next-button').disabled = true;
    }
  }

  checkDisclaimer(){
    const currentContainer = this.dom.$panelContainers[this.currentIndex]

    if (!currentContainer._$('.floor-plans-row__panel-disclaimer') && this.dom.$disclaimer){
      const node = this.dom.$disclaimer.cloneNode(true)
      node.hidden = false;
      currentContainer._$('.floor-plans-row__panel-controls-bottom').appendChild(node)

      this.dom.$anchorsInDisclaimer = this.el._$$('[href^="#"]');
      this.dom.$anchorsInDisclaimer._on('click', this.handleAnchorLinkClick.bind(this));
    }
  }

  handleNextClick(){
    this.nextContainer.style.transitionDuration = '0ms';
    this.dom.$panelContainers.forEach(el => { el.style.display = 'none'; el.classList.remove('active'); });
    this.nextContainer.classList.add('active');
    this.nextContainer.style.display = this.displayType;
    this.nextContainer.style.transitionDuration = null;
    this.currentIndex++;
    this.checkDisclaimer();
    this.checkNavigationButtonsLabels();
  }

  handlePrevClick(){
    this.prevContainer.style.transitionDuration = '0ms';
    this.dom.$panelContainers.forEach(el => { el.style.display = 'none'; el.classList.remove('active'); });
    this.prevContainer.classList.add('active');
    this.prevContainer.style.display = this.displayType;
    this.prevContainer.style.transitionDuration = null;
    this.currentIndex--;
    this.checkDisclaimer();
    this.checkNavigationButtonsLabels();
  }

  handleTransitionEnd(e) {
    if (!e.currentTarget.classList.contains('active')) {
      e.currentTarget.style.display = 'none';
    } else {
      this.dom.$triggers.forEach(el => {
        el.style.display = 'none';
      })
      this.dom.$sectionHead.style.display = 'none';
    }
  }

  handlePanelActivation(e) {
    const { room } = e.currentTarget.dataset;
    const panelContainer = this.dom.$panelContainers.find(el => el.dataset.room === room);
    this.currentIndex = this.dom.$panelContainers.indexOf(panelContainer);
    this.dom.$panelContainers.forEach(el => el.style.display = 'none')
    panelContainer.style.display = this.displayType;
    this.showPanel(panelContainer);
  }

  handleModalOpen(){
    this.dom.$panelContainers.forEach(el => el.style.height='0')
    this.dom.$panelInners.forEach(el => el.style.height='0')
  }

  handleModalClose(){
    this.dom.$panelContainers.forEach(el => el.style.height=null)
    this.dom.$panelInners.forEach(el => el.style.height=null)
  }

  handleClose(e) {
    if (e.currentTarget.classList.contains('floor-plans-row__panel-close-button')){
      this.dom.$panelContainers.forEach(el => {
        el.style.display = 'none';
        el.hidden = true;
      });
    }
    this.dom.$panelContainers.forEach(el => el.classList.remove('active'))
    this.dom.$triggers.forEach(el => {
      el.style.display = null;
    })
    this.dom.$sectionHead.style.display = null;
  }

  handleAnchorLinkClick(e) {
    const close = e.target?.closest?.('.floor-plans-row__panel-content-container')?._$?.('.floor-plans-row__panel-close-button');
    if (close) close.click();
  }
}

export default Module;
